/**
 * This class provides parameters that are commonly used in PC and Mobile Web.
 */
import UUID from '../utils/UUID';
export default class CommonWebParameter {
  private pvid: string;
  private rvid: string;
  private url: string;
  private referrer: string;

  constructor() {
    const currentUrl = window.location.href;
    const referrerUrl = document.referrer || '';

    this.setPvId(UUID.generate());
    this.setRvId(''); // Todo: rvid를 전달할 수 있는 방안이 마련된 후 작업하도록 한다.
    this.setReferrer(referrerUrl);
    this.setUrl(currentUrl);
  }

  /**
   * Returns JSON object of CommonWebParameter
   *
   * @returns {{web: {pvid: string, rvid: string, url: string, referrer: string}}}
   */
  getJSON(): CommonWebParameterType {
    const { pvid, rvid, url, referrer } = this;

    return {
      web: {
        pvid,
        rvid,
        url,
        referrer
      }
    };
  }

  /**
   * Set the pvid.
   *
   * @param rvid {string} Returns pvid
   */
  private setPvId(pvid: string) {
    this.pvid = pvid;
  }

  /**
   * Set rvid.
   *
   * @param rvid {string} Returns rvid
   */
  private setRvId(rvid: string) {
    this.rvid = rvid;
  }

  /**
   * Set the URL.
   *
   * @param url {string} Returns url
   */
  private setUrl(url: string) {
    this.url = url;
  }

  /**
   * Set Referrer.
   *
   * @param referrer {string} Returns referrer
   */
  private setReferrer(referrer: string) {
    this.referrer = referrer;
  }
}
